export const wait = (ms = 100) => new Promise((resolve) => setTimeout(resolve, ms))
